
const KCAKuma = () => {

  return (
    <div className="w-full min-h-screen bg-white">
      <div className="relative bg-[#14532d] text-white py-8 md:py-10 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
             Kings C. Akuma
          </h2>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 py-8 font-sans text-gray-800">

       
        <section>
          <div className="max-w-6xl mx-auto p-8 bg-white font-sans text-gray-700">
            <div className="flex flex-col md:flex-row gap-12">

              {/* Left Side: Image */}
              <div className="md:w-1/3">
                <div className="sticky top-24">
                  <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-green-700 to-yellow-400 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                    <img
                      src="/images/KC-Akuma.jpg"
                      alt="Kings C. Akuma"
                      className="relative w-full h-auto object-cover rounded-2xl shadow-2xl border-4 border-white"
                    />
                  </div>
                </div>
              </div>

              {/* Right Side: Content */}
              <div className="md:w-2/3">
                {/* Name and Title */}
                <header className="mb-12">
                  <h1 className="text-4xl font-black text-black mb-6 uppercase tracking-tight">PROFILE</h1>
                  <div className="text-lg leading-relaxed space-y-6 text-gray-600 font-medium">
                    <p>
                    Pastor Kings C. Akuma F.CIoD has extensive experience in providing leadership, direction, articulating and overseeing high level corporate strategies and growth plans into business and project operational action plans. His experience spans over four decades in profit improvement initiatives (PII), consulting, forensic analysis, internal control, due diligence, corporate governance, business & management turnaround initiatives, banking/finance operations, and community management, gained from scanning the wider horizon of the ever-changing corporate environments, including oil & gas, manufacturing, commerce, banking, power, and consultancy subsectors.
                    Pastor Akuma holds a Bachelor of Accounting degree from the University of Nigeria, Nsukka, Nigeria and a Master of Business Administration (MBA) degree from the University of Lagos, Nigeria.
                    </p>
                    <p>
                    He has attended several courses of the CIoD including The Role of the Chair, Independent Directors Master Class, the 2025 Annual Directors Conference, Corporate Governance seminars, in addition to completing the executive education programmes at Harvard Business School, INSEAD, Northwestern University Kellogg School of Management, Oxford University Said Business School, and Wharton School of the University of Pennsylvania. He was Chairman of the Programs & Events Committee, PH Zone (SS & SE), and is currently the Hon Secretary of the Zones' Chartered Institute of Directors.
                    </p>
                    <p>
                     He is a Fellow of the Institute of Chartered Accountants of Nigeria (ICAN), Chartered Institute of Taxation (CITN), and Nigeria Institute of Credit Administration (NICA), and member of the Institute of Chartered Mediators and Conciliators (ICMC). He had sat on the Boards and Board Committees of Fidelity Bank Plc, where he was a member of the Board Finance & General Purpose Committee, Board Audit Committee, Board Risk Committee, as well as the Shareholders Audit Committee. He, at various times, Chaired the Bank's Board Corporate Governance Committee, as well as the Board Credit Committee; At Nestoil Group, Pst Akuma served as Executive Director in charge of Operations and Quality, and later, Managing Director of the civil construction arm of the Group, Hammakopp Consortium Ltd. He also served on the Board of CIBN Centre for Financial Studies. Currently, He sits on the Board of Akyidson Group, Accesspro Technologies, and HEDO-BEC Engineering & Construction Ltd, as Managing Director/Chief Executive.
                    </p>
                    <p>
                    Pastor KC Akuma, is currently the Chairman of the Interim Board of the BEDC Electricity plc.   
                    </p>
                  </div>
                </header>  
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default KCAKuma;